import { $ } from "@utils/dom";

import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

const SWIPER_OPTIONS = {
  modules: [Pagination, Navigation],
  freeMode: false,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 12,
  speed: 600,
  breakpoints: {
    768: {
      spaceBetween: 16
    },
    1200: {
      spaceBetween: 30
    }
  }
};

class PbRowFeaturedMeals {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this.slider = $('.pb-row-featured-meals__slider', this.el);
  }

  init() {
    this.swiper = new Swiper(this.slider, { ...SWIPER_OPTIONS, ...{
      navigation: {
        prevEl: $('.pb-row-featured-meals__sliderPrev',this.el),
        nextEl: $('.pb-row-featured-meals__sliderNext',this.el),
      },
      pagination: {
        el: $('.pb-row-featured-meals__pagination',this.el),
        clickable: true
      }
    }});
  }
  destroy() {
    if( this.swiper ) this.swiper.destroy();

    this.el = null;
    this.emitter = null;
    this.swiper = null;
    this.slider = null;
  }

  start() { this._bindEvents(); }
  stop() { this._unbindEvents(); }

  _bindEvents() {}
  _unbindEvents() {}
}

export default PbRowFeaturedMeals;
